export default __webpack_public_path__ + "static/media/break.ff9f3128.png";